import React  from 'react';
import {Helmet} from 'react-helmet';

// import {getConfig} from './../config';

const Meta = ({title}) => {
  return (
    <Helmet>
      <title>{title} | CESI</title>
      {/* <link
        rel="icon"
        type="image/png"
        href={"https://cdn.ozwol.cloud/ozwol/favicon/"+getConfig("favicon")+".svg"}
        sizes="16x16"
      /> */}
    </Helmet>
  )
}

export default Meta;
